import _ from 'lodash'
import { MutationTree } from 'vuex'
import { LessonsState, Lesson } from '@/store/lessons/types'

const mutations: MutationTree<LessonsState> = {
  /**
   * レッスン情報を取得（複数件）
   * @param lessons レッスン情報
   */
  fetchedLessons: (state, lessons: Lesson[]) => {
    state.lessons = lessons
  },

  /**
   * レッスン情報を取得（１件）
   * @param state Lessonストアstate
   * @param lesson レッスン情報
   */
  gotLesson: (state, lesson: Lesson) => {
    state.lessons = _.uniqBy([
      lesson,
      ...state.lessons,
    ], 'scheduleId')
  },
}

export default mutations
